import { useViewedEvent } from './use-viewed-event';

type UseProjectsTabViewedEventParams = {
  username: string;
  enabled?: boolean;
};

export const useProjectsTabViewedEvent = ({
  username,
  enabled,
}: UseProjectsTabViewedEventParams) => {
  useViewedEvent({
    eventName: 'projects_tab_is_viewed',
    senderUsername: username,
    enabled,
  });
};
